import React, {useEffect, useState} from 'react';
import {Calendar, CreditCard, GiftIcon, Wallet} from 'lucide-react';
import {useApiReadStudentPaymentBalance} from "@/api/payment";
import RenderIf from "@/components/render-if";
import {Alert, Button, Input, List, Space, Spin, Typography} from "antd";
import toFaNumber from "@/lib/utils/number";
import {Link, useNavigate, useParams} from "react-router-dom";
import {useApiCreateStudentLessonTaken} from "@/api/lesson";
import {urlPath} from "@/lib/utils/url";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {URLS} from "@/lib/urls";
import {sprintf} from "@/lib/utils/sprintf";
import {useApiStudentCheckDiscountCode} from "@/api/discount";
import {toast} from "react-toastify";
import MoveClassModalComponent from "@/pages/student/lessons/take/[id]/_section/MoveClassModalComponent";

const {Title, Text} = Typography;

function LessonPricingSection({lessonDetail}) {
    const {data: balance, isSuccess: isSuccessBalance, isPending: isPendingBalance} = useApiReadStudentPaymentBalance()
    const [paymentType, setPaymentType] = useState('full'); // 'full' | 'installment'
    const [payablePrice, setPayablePrice] = useState(0)
    const [rawPayablePrice, setRawPayablePrice] = useState(0)
    const [studentBalance, setStudentBalance] = useState(0);
    const [discountCode, setDiscountCode] = useState('')
    const [appliedDiscountCode, setAppliedDiscountCode] = useState('')
    const [installmentList, setInstallmentList] = useState([])
    const [lessonPrice, setLessonPrice] = useState(0)
    const [payableAmountFull, setPayableAmountFull] = useState(0)
    const [moveClassModal, setMoveClassModal] = useState(false)


    const [discountCalculatedPrice, setDiscountCalculatedPrice] = useState({
        discountCalculated: false,
        base_amount: null,
        discount_amount: null,
        discount_percent: null,
        lesson_price: null,
        payable_amount: null,

    })


    const navigate = useNavigate();
    const param = useParams();
    const {mutate: studentRegisterLesson, isPending: isPendingTakeLesson} = useApiCreateStudentLessonTaken()
    const {mutate: checkDiscountCode, isPending: isPendingCheckDiscountCode} = useApiStudentCheckDiscountCode();

    const [loading, setLoading] = useState(false)

    function handleTakeLesson() {
        setLoading(true)
        studentRegisterLesson({
            id: param.id,
            installment: (paymentType === 'installment'),

            discount_code: appliedDiscountCode,
            discount_event: 'course_registration',
            discount_pay_type: paymentType,

            callback_url: urlPath()
        }, {
            onSuccess: (r) => {
                ApiHandleSuccessMessage(r)

                if (r?.data?.data?.redirect_url) {
                    window.location.href = r?.data?.data?.redirect_url;
                } else {
                    setLoading(false)

                    if (r?.data?.data?.id) {
                        navigate(sprintf(URLS.student.lessons.myLesson.detail, {id: r?.data?.data?.id}))
                    }
                }
            },
            onError: (e) => {
                if (e?.response?.data?.response_code === 'DUPLICATE_TOPIC_IN_ONE_SEMESTER') {
                    setMoveClassModal(true)
                } else {
                    ApiHandleErrorMessage(e)
                }

                setLoading(false)
            },

        })
    }


    useEffect(() => {
        handleDiscountCode(appliedDiscountCode)
    }, [paymentType]);


    useEffect(() => {
        if (balance?.data) {
            setStudentBalance(balance?.data?.data?.budget);
        }
    }, [balance])

    function removeAppliedDiscountCode() {
        setDiscountCalculatedPrice({...discountCalculatedPrice, discountCalculated: false});
        setPayablePrice(rawPayablePrice)
        setInstallmentList(lessonDetail?.topic?.installments)
        setLessonPrice(lessonDetail?.price)
        setPayableAmountFull(lessonDetail?.price)
        setAppliedDiscountCode('')
        calculatePayableAmount()
    }

    function handleDiscountCode(discount) {
        if (!discount) {
            removeAppliedDiscountCode()
            return;

        }

        checkDiscountCode({
            discount_code: discount,
            lesson_id: param.id,
            discount_event: 'course_registration',
            installment: (paymentType === 'installment') ? 1 : 0,
            pay_type: paymentType
        }, {
            onSuccess: (r) => {
                if (r?.data?.data) {
                    setDiscountCalculatedPrice({...r.data?.data, discountCalculated: true})
                    setAppliedDiscountCode(discount)
                    toast.success(' کد تخفیف برای شما اعمال شد')
                    if (r?.data?.data?.payable_amount || r?.data?.data?.payable_amount === 0) {
                        setPayablePrice(r?.data?.data?.payable_amount)
                    }

                    setLessonPrice(r?.data?.data?.lesson_price)
                    setPayableAmountFull(r?.data?.data?.payable_amount_full)

                    if (r?.data?.data?.discount_installment) {
                        setInstallmentList(r?.data?.data?.discount_installment)
                    }
                }

            },
            onError: (e) => {
                ApiHandleErrorMessage(e)
                removeAppliedDiscountCode()
            }

        })

    }

    useEffect(() => {
        if (lessonDetail?.topic?.installments?.length > 0) {
            setInstallmentList(lessonDetail?.topic?.installments);
        }
        setLessonPrice(parseInt(lessonDetail?.price ?? 0))
        setPayableAmountFull(parseInt(lessonDetail?.price ?? 0))


    }, [lessonDetail]);


    useEffect(() => {
        calculatePayableAmount()
    }, [studentBalance, paymentType, lessonDetail, payableAmountFull, discountCalculatedPrice])

    function calculatePayableAmount() {
        let payablePrice = 0;
        let myLessonPrice = 0;
        if (paymentType === 'installment' && installmentList.length > 0) {
            myLessonPrice = parseInt(installmentList[0]?.price ?? 0);
        } else {
            if (discountCalculatedPrice.discountCalculated) {
                myLessonPrice = parseInt(discountCalculatedPrice.lesson_price);
            } else {

                myLessonPrice = parseInt(lessonDetail?.price);
            }
        }

        if (myLessonPrice > 0) {
            if (studentBalance < 0) {
                payablePrice = myLessonPrice + (studentBalance * -1)
            }

            if (studentBalance >= 0) {
                let remainPayablePrice = studentBalance - myLessonPrice;
                if (remainPayablePrice >= 0) {
                    payablePrice = 0
                }
                if (remainPayablePrice < 0) {
                    payablePrice = remainPayablePrice * -1
                }

            }
        }


        setPayablePrice(payablePrice)
        setRawPayablePrice(payablePrice)
    }

    const formatPrice = (price) => {
        if (typeof (price) === 'undefined') {
            return price
        }
        return price.toLocaleString('fa-IR') + ' تومان';
    };


    if (lessonDetail?.price === 0) {
        return (<>

            <RenderIf condition={lessonDetail?.takenunits && lessonDetail?.takenunits.length > 0}>
                <Alert type="success"
                       message={'شما قبلا در این درس ثبت‌نام کرده‌اید'}
                       description={<Link to={URLS.student.lessons.myLesson.list}>برای مشاهده درس‌های ثبت‌نام
                           کرده
                           اینجا
                           کلیک کنید</Link>}
                       showIcon={true}>
                </Alert>
            </RenderIf>

            <div className="flex my-2">
                <Button
                    variant={'solid'}
                    color={'cyan'}
                    size={'large'}
                    className={'w-full'}
                    loading={loading}
                    onClick={() => handleTakeLesson()}

                >

                    <div className="flex items-center justify-center gap-2">

                        <RenderIf condition={payablePrice > 0} falsyElement={'ثبت‌نام'}>
                            <CreditCard className="w-5 h-5"/>
                        </RenderIf>

                    </div>
                </Button>
                <Button size={'large'} variant={'dashed'} color={'default'} className={'mx-1'}
                        onClick={() => navigate(-1)}>
                    بازگشت</Button>
            </div>

        </>)
    }


    return (<>

            <MoveClassModalComponent
                lessonDetail={lessonDetail}
                id={param.id}
                moveClassModal={moveClassModal} setMoveClassModal={setMoveClassModal}/>

            <div className="w-full  rounded-2xl shadow-2xl overflow-hidden my-2">
                {/* Header */}
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-6 ">
                    <div className="flex items-center gap-3">
                        <CreditCard className="w-6 h-6"/>
                        <h2 className="text-xl font-bold">هزینه ثبت‌نام</h2>
                    </div>
                    <p className="text-blue-100 mt-2 text-sm">{lessonDetail?.topic?.title}</p>
                </div>

                <div className="p-6 space-y-6">
                    {/* Class Price */}
                    <div className="rounded-xl p-4">
                        <div className="flex justify-between items-center">
                            <span className=" font-medium">قیمت کلاس:</span>
                            <RenderIf condition={discountCalculatedPrice.discountCalculated}>
                                <div className="flex items-center gap-2">
                            <span
                                className="line-through decoration-2 decoration-red-500 text-2xl font-bold ">
                                {formatPrice(lessonDetail?.price ?? 0)}
                            </span>
                                    <span className="text-2xl font-bold ">
                                    {formatPrice(discountCalculatedPrice.lesson_price ?? 0)}
                              </span>
                                </div>

                            </RenderIf>

                            <RenderIf condition={!discountCalculatedPrice.discountCalculated}>

                                <RenderIf condition={!!lessonDetail?.price}>
                              <span className="text-2xl font-bold ">
                                {formatPrice(lessonDetail?.price ?? 0)}
                              </span>
                                </RenderIf>
                                <RenderIf condition={payablePrice === 0}>
                              <span className="text-2xl font-bold text-green-900">
                                رایگان
                              </span>
                                </RenderIf>

                            </RenderIf>


                        </div>
                    </div>
                    <RenderIf condition={lessonDetail?.price !== 0}>


                        {/* Discount Code */}
                        <div className=" rounded-xl p-4">
                            <div className="flex justify-between items-center">
                                <div className="flex items-center gap-4 flex-wrap ">
                                    <GiftIcon className="w-5 h-5 text-blue-600 dark:text-blue-300"/>
                                    <span className="text-blue-800 dark:text-blue-300 font-medium">کد تخفیف</span>
                                    <RenderIf condition={discountCalculatedPrice.discountCalculated}>

                                        <div
                                            className=" -top-3 -right-3 bg-gradient-to-r from-rose-500 to-red-600  px-4 py-2 rounded-full shadow-lg font-bold text-sm ">
                                            {discountCalculatedPrice.discount_percent ?? 0}% تخفیف
                                        </div>
                                    </RenderIf>

                                </div>
                                <div className={''}>
                                    <Input type={'text'} size={'large'} variant={'outlined'}
                                           onChange={(e) => setDiscountCode(e.target.value)}
                                           allowClear={true}
                                           onClear={() => handleDiscountCode(null)}
                                    />

                                    <Button
                                        size={'large'}
                                        type={'default'}
                                        className={'my-2'}

                                        onClick={() => handleDiscountCode(discountCode)}
                                        loading={isPendingCheckDiscountCode}
                                        variant={'link'}>ثبت تخفیف</Button>
                                </div>

                            </div>
                        </div>
                    </RenderIf>

                    <RenderIf condition={lessonDetail?.price !== 0}>

                        {/* Payment Type Selection */}
                        <RenderIf condition={!!lessonDetail?.installment}>
                            <div className="space-y-3">
                                <h3 className="font-semibold  mb-3">نوع پرداخت:</h3>

                                {/* Full Payment */}
                                <div
                                    className={`border-2 rounded-xl p-4 cursor-pointer transition-all duration-200 ${paymentType === 'full' ? 'border-blue-500 ' : 'border-gray-200 hover:border-gray-300'}`}
                                    onClick={() => setPaymentType('full')}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-3">
                                            <div
                                                className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${paymentType === 'full' ? 'border-blue-500' : 'border-gray-300'}`}>
                                                {paymentType === 'full' && (
                                                    <div className="w-2 h-2 rounded-full"></div>)}
                                            </div>
                                            <div>
                                                <span className="font-medium ">پرداخت کامل</span>
                                                <p className="text-sm ">پرداخت یکجای کل مبلغ</p>
                                            </div>
                                        </div>
                                        <span className="font-bold ">
                    {formatPrice(payableAmountFull)}
                  </span>
                                    </div>
                                </div>

                                {/* Installment Payment */}
                                <div
                                    className={`border-2 rounded-xl p-4 cursor-pointer transition-all duration-200 ${paymentType === 'installment' ? 'border-green-500 bg-green-50' : 'border-gray-200 hover:border-gray-300'}`}
                                    onClick={() => setPaymentType('installment')}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-3">
                                            <div
                                                className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${paymentType === 'installment' ? 'border-green-500' : 'border-gray-300'}`}>
                                                {paymentType === 'installment' && (
                                                    <div className="w-2 h-2 bg-green-500 rounded-full"></div>)}
                                            </div>
                                            <div>
                                                <div className="flex items-center gap-2">
                                                    <Calendar className="w-4 h-4 text-green-600"/>
                                                    <span className="font-medium ">پرداخت قسطی</span>
                                                </div>
                                                <p className="text-sm ">
                                                    {installmentList?.length} قسط
                                                </p>
                                            </div>
                                        </div>
                                        <div className="text-left">
                    <span className="font-bold ">
                      {formatPrice((installmentList && installmentList.length > 0) ? installmentList[0]?.price : 0)}
                    </span>
                                            <p className="text-xs ">قسط اول</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Installment Info */}
                            <RenderIf condition={paymentType === 'installment'}>
                                <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-2">
                                    <div className="flex gap-2">
                                        <Calendar className="w-5 h-5 text-yellow-600 mt-0.5"/>
                                        <div className="text-sm text-yellow-800 flex-1">
                                            <p className="font-medium mb-1">اطلاعات قسط‌بندی:</p>

                                            <List
                                                className={'w-full'}
                                                dataSource={installmentList}
                                                renderItem={(installment, index) => (
                                                    <List.Item className="border-b last:border-b-0">
                                                        <List.Item.Meta
                                                            avatar={
                                                                <div
                                                                    className=" rounded-full w-10 h-10 flex items-center justify-center">
                                                                    <Text strong>{toFaNumber(index + 1)}</Text>
                                                                </div>
                                                            }
                                                            title={`قسط ${toFaNumber(index + 1)}`}
                                                            description={
                                                                <Space direction="vertical">
                                                                    <Text strong className=" text-green-600">
                                                                        {formatPrice(installment?.price)}
                                                                    </Text>
                                                                    <RenderIf condition={!!installment.diff_days}>
                                                                        <Text type="secondary">
                                                                            پرداخت
                                                                            تا {toFaNumber(installment?.diff_days)} روز
                                                                            بعد
                                                                        </Text>

                                                                    </RenderIf>
                                                                    <RenderIf condition={index === 0}>
                                                                        <Text type="secondary">
                                                                            پرداخت هم اکنون
                                                                        </Text>

                                                                    </RenderIf>
                                                                </Space>
                                                            }
                                                        />
                                                    </List.Item>
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </RenderIf>
                        </RenderIf>


                        {/* Student Balance */}
                        <div className=" rounded-xl p-4">
                            <div className="flex justify-between items-center">
                                <div className="flex items-center gap-2">
                                    <Wallet className="w-5 h-5 text-blue-600 dark:text-blue-300"/>
                                    <span className="text-blue-800 dark:text-blue-300 font-medium">موجودی شما:</span>
                                </div>
                                <RenderIf condition={isPendingBalance}>
                                    <Spin/>
                                </RenderIf>
                                <RenderIf condition={isSuccessBalance}>
                                    <span
                                        className={`text-xl font-bold ${balance?.data?.data?.budget < 0 ? 'text-red-700' : 'text-blue-900'} `}>
                                            {formatPrice(balance?.data?.data?.budget ?? 0)}
                                    </span>
                                </RenderIf>
                            </div>
                        </div>


                        {/* Payment Summary */}
                        <div className="border-t pt-4 space-y-3">
                            <div className="flex justify-between items-center">
                                <span className="">مبلغ قابل پرداخت:</span>
                                <span className="text-xl font-bold text-blue-600 dark:text-blue-300">
                {formatPrice(payablePrice)}
              </span>
                            </div>


                        </div>
                    </RenderIf>

                    <RenderIf condition={lessonDetail?.takenunits && lessonDetail?.takenunits.length > 0}>
                        <Alert type="success"
                               message={'شما قبلا در این درس ثبت‌نام کرده‌اید'}
                               description={<Link to={URLS.student.lessons.myLesson.list}>برای مشاهده درس‌های ثبت‌نام
                                   کرده
                                   اینجا
                                   کلیک کنید</Link>}
                               showIcon={true}>
                        </Alert>
                    </RenderIf>

                    <div className="flex">
                        <Button
                            variant={'solid'}
                            color={'cyan'}
                            size={'large'}
                            className={'w-full'}
                            loading={loading}
                            onClick={() => handleTakeLesson()}

                        >

                            <div className="flex items-center justify-center gap-2">

                                <RenderIf condition={payablePrice > 0} falsyElement={'ثبت‌نام'}>
                                    <CreditCard className="w-5 h-5"/>
                                    پرداخت {paymentType === 'installment' ? 'قسط اول' : 'کامل'}
                                    {' '}
                                    {formatPrice(payablePrice)}
                                </RenderIf>

                            </div>
                        </Button>
                        <Button size={'large'} variant={'dashed'} color={'default'} className={'mx-1'}
                                onClick={() => navigate(-1)}>
                            بازگشت</Button>
                    </div>


                </div>
            </div>

        </>
    );
}

export default LessonPricingSection;
